import PageHero from '@components/common/PageHero'

const FAMILY = "'DM Sans', sans-serif"
const AMBER  = '#ed9716'
const TEXT   = '#2d2d2d'

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '36px' }}>
      <h2 style={{
        fontFamily: FAMILY, fontSize: '11px', fontWeight: 700,
        letterSpacing: '0.13em', textTransform: 'uppercase',
        color: AMBER, margin: '0 0 10px',
      }}>
        {title}
      </h2>
      <div style={{ width: '24px', height: '2px', background: AMBER, marginBottom: '16px' }} />
      {children}
    </div>
  )
}

function P({ children }) {
  return (
    <p style={{
      fontFamily: FAMILY, fontSize: '14.5px', color: TEXT,
      lineHeight: 1.85, margin: '0 0 14px',
    }}>
      {children}
    </p>
  )
}

function UL({ items }) {
  return (
    <ul style={{ margin: '0 0 14px', paddingLeft: '20px' }}>
      {items.map((item, i) => (
        <li key={i} style={{
          fontFamily: FAMILY, fontSize: '14.5px', color: TEXT,
          lineHeight: 1.85, marginBottom: '6px',
        }}>
          {item}
        </li>
      ))}
    </ul>
  )
}

export default function TermsOfUsePage() {
  return (
    <>
      <PageHero
        title="Terms of Use"
        breadcrumbs={[
          { label: 'Home', to: '/' },
          { label: 'Terms of Use' },
        ]}
      />

      <div style={{ background: '#ffffff' }}>
        <div style={{
          maxWidth: 'var(--container-max)', margin: '0 auto',
          padding: '60px var(--container-padding) 80px',
        }}>
          <p style={{
            fontFamily: FAMILY, fontSize: '13.5px', color: '#888',
            marginBottom: '48px',
          }}>
            Last updated: April 2025
          </p>

          <Section title="Acceptance of Terms">
            <P>
              By accessing and using the website salientagrinutrition.com, you accept and agree
              to be bound by these Terms of Use. If you do not agree to these terms, please do
              not use this website.
            </P>
          </Section>

          <Section title="Use of This Website">
            <P>
              This website is provided for informational and commercial enquiry purposes relating
              to the products and services of Salient Agrinutrition Pvt. Ltd. You agree to use
              this website only for lawful purposes and in a manner that does not infringe the
              rights of others.
            </P>
            <P>You must not:</P>
            <UL items={[
              'Use the website in any way that is unlawful, fraudulent, or harmful.',
              'Attempt to gain unauthorised access to any part of the website or its related systems.',
              'Transmit any unsolicited or unauthorised advertising or promotional material.',
              'Reproduce, duplicate, or copy any part of the website without our express written permission.',
            ]} />
          </Section>

          <Section title="Intellectual Property">
            <P>
              All content on this website — including text, images, graphics, logos, and the
              Salient Agrinutrition name and brand — is the property of Salient Agrinutrition
              Pvt. Ltd. or its content suppliers, and is protected by applicable intellectual
              property laws.
            </P>
            <P>
              You may not reproduce, distribute, or use any content from this website for
              commercial purposes without our prior written consent.
            </P>
          </Section>

          <Section title="Product Information">
            <P>
              The product and service information on this website is provided for general
              informational purposes only. Specifications, availability, and pricing may change
              without notice. Contact us directly for the most current information.
            </P>
          </Section>

          <Section title="Disclaimer of Warranties">
            <P>
              This website is provided on an "as is" and "as available" basis without any
              warranties of any kind, either express or implied. We do not warrant that the
              website will be uninterrupted, error-free, or free of viruses or other harmful
              components.
            </P>
          </Section>

          <Section title="Limitation of Liability">
            <P>
              To the fullest extent permitted by law, Salient Agrinutrition Pvt. Ltd. shall not
              be liable for any indirect, incidental, or consequential damages arising from your
              use of, or inability to use, this website or its content.
            </P>
          </Section>

          <Section title="External Links">
            <P>
              This website may contain links to third-party websites. These links are provided
              for your convenience only. We have no control over the content of those sites and
              accept no responsibility for them or for any loss or damage that may arise from
              your use of them.
            </P>
          </Section>

          <Section title="Changes to These Terms">
            <P>
              We reserve the right to update these Terms of Use at any time. Changes will be
              effective immediately upon posting to this page. Continued use of the website
              after any changes constitutes your acceptance of the revised terms.
            </P>
          </Section>

          <Section title="Governing Law">
            <P>
              These Terms of Use are governed by and construed in accordance with the laws of
              the Democratic Socialist Republic of Sri Lanka. Any disputes arising in connection
              with these terms shall be subject to the exclusive jurisdiction of the courts of
              Sri Lanka.
            </P>
          </Section>

          <Section title="Contact Us">
            <P>
              For any questions regarding these Terms of Use, please contact:
            </P>
            <UL items={[
              'Email: info@salientagrinutrition.com',
              'Phone: +94 718 919 034',
              'Address: No.51/D, P.T.S. Avenue, Dalugama, Kelaniya, Sri Lanka',
            ]} />
          </Section>
        </div>
      </div>
    </>
  )
}
